import {
  Button,
  ButtonColorEnum,
  ButtonSizeEnum,
  ButtonTypesEnum,
  ButtonVariantEnum,
  IconSizeEnum,
  SpinnerIcon,
  TextButtonColorEnum,
} from '@acceso/design-system';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type TFooterFormActionsProps<T extends FieldValues> = {
  form: UseFormReturn<T, T, undefined>;
  cancelActionLabel?: string;
  submitActionLabel?: string;
  handleSubmit: (data: T) => void;
  handleCancel?: () => void;
  isLoading?: boolean;
};

export function FooterFormActions<T extends FieldValues>({
  form,
  cancelActionLabel,
  submitActionLabel,
  handleSubmit,
  handleCancel,
  isLoading = false,
}: TFooterFormActionsProps<T>) {
  const { t } = useTranslation();
  return (
    <div className="flex w-full justify-end">
      <div className="flex gap-2">
        {handleCancel && (
          <Button
            variant={ButtonVariantEnum.TEXT}
            color={TextButtonColorEnum.DEFAULT}
            size={ButtonSizeEnum.MD}
            onClick={handleCancel}
          >
            {cancelActionLabel || t('Cancelar')}
          </Button>
        )}
        <Button
          type={ButtonTypesEnum.SUBMIT}
          color={ButtonColorEnum.DEFAULT}
          size={ButtonSizeEnum.MD}
          disabled={isLoading}
          onClick={form.handleSubmit(handleSubmit)}
        >
          <span className="flex items-center gap-2">
            {isLoading && <SpinnerIcon size={IconSizeEnum.SM} />}
            {submitActionLabel || t('Guardar')}
          </span>
        </Button>
      </div>
    </div>
  );
}
